import React, { useState } from 'react';

import LinearProgress from '../../../../../components/modules/LinearProgress';
import PhotoUpload from '../../../../../components/modules/PhotoUpload';
import CrossIcon from '../../../../../assets/icons/cross.svg';
import Modal from '../../../../../components/modules/Modal';
import styles from './SidebarModals.module.scss';

type TUploadPhotoModal = {
  open: boolean;
  setOpen: (bool: boolean) => void;
};

const UploadPhotoModal: React.FC<TUploadPhotoModal> = ({ open, setOpen }) => {
  const [cropAvatar, setCropAvatar] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);

  const switchModal = () => {
    setOpen(!open);
  };

  return (
    <Modal open={open} onClose={switchModal}>
      {isFileUploading && <LinearProgress />}
      <div className={styles.modalContainer}>
        <div className={styles.modalTitle}>
          {cropAvatar ? 'Crop avatar' : 'Upload avatar'}
          <img src={CrossIcon} alt="cross" onClick={switchModal} />
        </div>
        <form style={{ display: 'flex', flexDirection: 'column' }}>
          <div className={styles.photoUpload}>
            <PhotoUpload setOpen={setOpen} setCropAvatar={setCropAvatar} setIsFileUploading={setIsFileUploading} />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default UploadPhotoModal;
